import { render, staticRenderFns } from "./StudyResultLastMinuteCheck.vue?vue&type=template&id=0a9c1872&lang=pug"
import script from "./StudyResultLastMinuteCheck.vue?vue&type=script&lang=ts"
export * from "./StudyResultLastMinuteCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports